import queries from '@apis/queries';
import MyShopApi from '@apis/shop/MyShopApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { ShopInMapRow } from '@models/shop';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState, MouseEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useShopFavorite(shop: ShopInMapRow) {
    const [isMyShop, setIsMyShop] = useState(shop.isMyShop);
    const { t } = useTranslation('shopList');
    const toast = useToast();
    const queryClient = useQueryClient();
    const [isLoading, setIsLoading] = useState(false);
    const { mutate } = useMutation({
        mutationFn: MyShopApi.toggleMyShop,
        onMutate() {
            setIsLoading(true);
        },
        onSuccess() {
            queryClient.invalidateQueries({
                queryKey: queries.shop._def,
            });
            if (isMyShop) {
                toast.success(t('toast.myShopRemoved'));
            } else {
                toast.success(t('toast.myShopAdded'));
            }
            setIsMyShop(!isMyShop);
        },
        onError(e: AxiosError<ErrorResponse>) {
            console.error(e);
            toast.error(e?.response?.data.message || t('toast.error'));
        },
        onSettled() {
            setIsLoading(false);
        },
    });
    const toggleMyShop = (e: MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (!isLoading) {
            mutate(shop.id);
        }
    };
    useEffect(() => {
        setIsMyShop(shop.isMyShop);
    }, [shop]);
    return {
        isMyShop, toggleMyShop,
    };
}

export default useShopFavorite;
